import { AdvComModule, JkmultiselectComponent } from "jk-advcom";
import { MaterialModule, JackBaseComponentModule, jkGlb, kmAttach, jkLib, minioAttachPath, JkBaseOption, idNameItem, JkdaterangeComponent, JkComboboxComponent } from "jk-service";
import { Component, ChangeDetectionStrategy, ViewChild, output } from "@angular/core";
import { OnInit } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { Mtrki02PkgComponent } from "./mtrki02Pkg.component";
import { Mtrwb } from "../_entity_mtr";
import { MtrwbService } from "../services/mtrwb.service";

export class PageOption extends JkBaseOption { // ###
  date1: string = '';
  date2: string = '';
  userList: idNameItem[] = [];
  finalCode: string = 'N';
  finalCodeList: idNameItem[] = [
    { id: 'N', name: '未結案' },
    { id: 'Y', name: '已結案' },
    { id: '', name: '全部' },
  ];
  departmentList: idNameItem[] = [];

  constructor(name: string) {// ###
    super(name);
  }
}

@Component({
  selector: 'app-mtrki02',
  standalone: true,
  providers: [],
  imports: [MaterialModule, JackBaseComponentModule, AdvComModule],
  templateUrl: './mtrki02.component.html', // ###
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki02Component extends Mtrki02PkgComponent implements OnInit {
  //override _programId = 'mtrki02';

  @ViewChild('wb003Filter') wb003Filter!: JkmultiselectComponent;
  @ViewChild('wb004Filter') wb004Filter!: JkdaterangeComponent;
  @ViewChild('wb014Filter') wb014Filter!: JkComboboxComponent;
  @ViewChild('wb006Filter') wb006Filter!: JkmultiselectComponent;

  override get srv(): MtrwbService {
    return this.masterSrv;
  }
  override set srv(value: MtrwbService) {
    this.masterSrv = value;
  }
  pageOpt: PageOption = new PageOption(this.programId);//###
  constructor() {
    super();
  }
  override onMasterTabChange($event: MatTabChangeEvent) {
    super.onMasterTabChange($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    if (this.srv.isAdmin) {
      this.qbeConfig.addField =
        'WB004,WB024,WB003,WB005,WB012,WB013,WB014,WB028'; // ### jackie
      this.qbeConfig.addWhere = ''; // ### jackie
    } else {
      this.qbeConfig.addField = 'WB004,WB005,WB012,WB013,WB014,WB028'; // ### jackie
      this.qbeConfig.addWhere = ''; // ### jackie
    }
    this.srv.setOrder('1');
    this.doRefresh();
  }

  override getImagePath(item: Mtrwb): string {
    return `${item.WB001}-${item.WB002}` || 'unknown';
  }

  doUploadMinio() {
    const item = this.item; // this.masterGrid.selectedItem;
    if (!jkLib.haveValue(item)) {
      alert('請先選單號!!!');
      return;
    }
    if (item.WB001 === '' || item.WB002 === '') {
      alert('請先選單號!!!');
    } else {
      const uploadHost = this.login.host;
      minioAttachPath(
        this.dialog,
        uploadHost,
        this.getImagePath(item),
      ).subscribe((result) => {
        if (result) {
          const files = result.rowsAffected;
          if (files) {
            if (typeof files === 'number') {
              // item.WB035 = item.WB035 + files; TODO:
            }
          }
        } //if
      });
    }
  }

  doUpload(item: Mtrwb) {
    if (!jkLib.haveValue(item)) {
      alert('請先選單號!!!');
      return;
    }
    if (item.WB001 === '' || item.WB002 === '') {
      alert('請先選單號!!!');
    } else {
      //var urlUpload = "http://www.jack168.com/upload/default.aspx"; // ?path=//nas5/Public/附件區/" + jkGlb.User.dbname() + "/YYYYMM/工作日報/W102-" + TD002;
      // DBNAME/工作日報/年月/單別-單號
      // urlUpload = urlUpload + "?path=C:/rd/附件區/" + jkGlb.User.dbname + "/" + myTable.getField("CREATE_DATE").substring(0, 6) + "/" + myTable.billType() + "-" + myTable.billNo();
      //urlUpload = urlUpload + "?path=D:/附件區/" + this.login.dbname + "/" + this.item.CREATE_DATE.substring(0, 6) + "/" + this.entityType.billType + "-" + this.entityType.billNo;
      // JkuploadComponent TODO: 測試
      let uploadHost = jkGlb.env.baseAttachUrl; //"http://rmserver.jack168.com/emonapp/upload/default.aspx";
      if (!uploadHost) {
        uploadHost = this.login.host;
      }
      let basePath = '/mnt/附件區';
      // \\jkw10-vm\data\附件區 --> /mnt/附件區
      //let uploadDirectory = `${basePath}/${this.login.dbname}/${date.substring(0, 6)}/${this.srv.entityType.billType}-${this.srv.entityType.billNo}`;
      kmAttach(
        this.dialog,
        this.login.dbname,
        uploadHost,
        basePath,
        item.CREATE_DATE,
        this.srv.entityType.billType,
        item.WB002,
      ).subscribe((result) => {
        if (result) {
          const files = result.rowsAffected;
          if (files) {
            if (typeof files === 'number') {
              // item.WB035 = item.WB035 + files; TODO:
            }
          }
        } //if
      });
    }
  }
  async doAdvQuery() {
    let where = ''; // this.masterSrv.sqlWhereDefault;
    const order = this.masterSrv.sqlOrderDefault;
    where = this.wb003Filter.addWhere(where, 'MTRWB.WB003');
    where = this.wb004Filter.addWhere(where, 'MTRWB.WB004');
    where = this.wb014Filter.addWhere(where, 'MTRWB.WB014');
    where = this.wb006Filter.addWhere(where, 'MTRWB.WB006');

    //this.pageOpt.save();
    this.masterTabGroupIndex = 1;
    await this.directQuery(where, order);
  }
}
